import RedirectLinkList from './RedirectLinkList'

export default RedirectLinkList